import React, { useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNotification } from '../../context/NotificationContext';
import AppToast from './AppToast';
import { APP_TOAST_AUTO_HIDE_MS, getAppToastCssVars } from './appToastTheme';

const AppToastHost = () => {
  const { notification, setNotification } = useNotification();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const cssVars = useMemo(() => getAppToastCssVars(isDark), [isDark]);

  useEffect(() => {
    if (!notification.open) return undefined;
    const timer = setTimeout(() => {
      setNotification((prev) => ({ ...prev, open: false }));
    }, APP_TOAST_AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [notification.open, notification.message, setNotification]);

  const handleDismiss = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  return (
    <AppToast
      open={notification.open}
      message={notification.message}
      severity={notification.severity}
      onDismiss={handleDismiss}
      style={cssVars}
    />
  );
};

export default AppToastHost;
